import { EmptyData } from '@infotech/base-components'

const EquipmentNameFormatter = ({ value, data = value }) => data || EmptyData()

export default EquipmentNameFormatter
